import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const GenerateManualReportSchema = z.object({
  body: z.object({
    declarantId: z.string(),
    year: z.number(),
    month: z.number(),
  }),
});

export type GenerateManualReportRequest = z.infer<typeof GenerateManualReportSchema>;

export const adminReportContract = c.router({
  generateManualReport: {
    method: 'POST',
    path: '/admin/generate-manual-report',
    body: z.object({
      declarantId: z.string(),
      year: z.number(),
      month: z.number(),
    }),
    responses: {
      200: c.otherResponse({
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        body: z.any(),
      }),
    },
  },
});
